@if (!hasData()) {
    <alert type="info" class="mb-3">No timesheet data to display.</alert>
} @else {
    <div class="d-flex align-items-center gap-2 mb-2">
        <h5 class="mb-0">Timesheet Debug</h5>
        <span class="badge text-bg-secondary">
            {{ summaryCountText() }}
        </span>
    </div>

    <accordion [isAnimated]="true">
        <accordion-group heading="Summary" [isOpen]="true">
            <div class="row">
                <div class="col-md-6">
                    <dl class="row small">
                        <dt class="col-5">Start of work</dt>
                        <dd class="col-7">{{ modelDisplay().startOfWork }}</dd>

                        <dt class="col-5">End of work</dt>
                        <dd class="col-7">{{ modelDisplay().endOfWork }}</dd>

                        <dt class="col-5">Submitted</dt>
                        <dd class="col-7">
                            <span
                                class="badge"
                                [class.text-bg-success]="modelDisplay().isSubmitted"
                                [class.text-bg-secondary]="!modelDisplay().isSubmitted"
                            >
                                {{ modelDisplay().isSubmitted ? 'Yes' : 'No' }}
                            </span>
                        </dd>

                        <dt class="col-5">Attendance type</dt>
                        <dd class="col-7">{{ modelDisplay().attendanceType }}</dd>

                        <dt class="col-5">Start address (raw)</dt>
                        <dd class="col-7">
                            <code class="text-muted">{{ modelDisplay().startAddressValue }}</code>
                        </dd>

                        <dt class="col-5">End address (raw)</dt>
                        <dd class="col-7">
                            <code class="text-muted">{{ modelDisplay().endAddressValue }}</code>
                        </dd>
                    </dl>
                </div>

                <div class="col-md-6">
                    <dl class="row small">
                        <dt class="col-5">Save timestamp</dt>
                        <dd class="col-7">{{ modelDisplay()?.saveTimestamp }}</dd>

                        <dt class="col-5"># Notifications</dt>
                        <dd class="col-7">{{ workEntriesByNotification().size }}</dd>

                        <dt class="col-5"># Manual entries</dt>
                        <dd class="col-7">{{ manualEntries().length }}</dd>
                    </dl>
                </div>
            </div>
        </accordion-group>

        <accordion-group
            [isOpen]="workEntriesByNotification().size > 0"
            heading="Work entries ({{ workEntriesByNotification().size }})"
        >
            @if (workEntriesByNotification().size === 0) {
                <div class="text-muted small">No notifications.</div>
            } @else {
                <div class="stack gap-3">
                    @for (n of workEntriesByNotification() | keyvalue; track $index) {
                        <pace-core-workentry-ngrx-spector
                            [addressesById]="addressesById()"
                            [workEntries]="n.value"
                            [notification]="findNotification(n.key)"
                        ></pace-core-workentry-ngrx-spector>
                        <hr class="my-2" />
                    }
                </div>
            }
        </accordion-group>

        <accordion-group [isOpen]="manualEntries().length > 0" heading="Manual entries ({{ manualEntries().length }})">
            @if (manualEntries().length === 0) {
                <div class="text-muted small">No manual entries.</div>
            } @else {
                <div class="table-responsive">
                    <table class="table table-sm table-striped align-middle">
                        <thead class="table-light">
                            <tr>
                                <th class="text-nowrap">Start</th>
                                <th class="text-nowrap">End</th>
                                <th class="text-nowrap">Task type</th>
                                <th class="text-nowrap">Travel type</th>
                                <th class="text-nowrap">Billable</th>
                                <th>Address</th>
                                <th>Notification ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (m of manualEntries(); track $index) {
                                <tr>
                                    <td class="text-nowrap">{{ fmtDateTime(m.start) }}</td>
                                    <td class="text-nowrap">{{ fmtDateTime(m.end) }}</td>
                                    <td>{{ m.taskType || '—' }}</td>
                                    <td>{{ workCodeLabel(m.travelType) }}</td>
                                    <td>
                                        <span
                                            class="badge"
                                            [class.text-bg-success]="m.isTravelBillable"
                                            [class.text-bg-secondary]="!m.isTravelBillable"
                                        >
                                            {{ m.isTravelBillable ? 'Yes' : 'No' }}
                                        </span>
                                    </td>
                                    <td class="small">
                                        {{ formatAddress(m.address) }}
                                        @if (m.addressInOutModel) {
                                            <span class="badge text-bg-info ms-1">IN/OUT</span>
                                        }
                                    </td>
                                    <td class="small">
                                        {{ m.notificationId?.frontId || '—' }}
                                        @if (m.notificationId?.qmNum) {
                                            <span class="text-muted"> (QM {{ m.notificationId?.qmNum }})</span>
                                        }
                                        @if (m.notificationId?.maNum) {
                                            <span class="text-muted"> (MA {{ m.notificationId?.maNum }})</span>
                                        }
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            }
        </accordion-group>

        <accordion-group heading="Raw JSON">
            <div class="d-flex flex-row justify-content-end gap-2">
                <button type="button" class="btn btn-sm btn-info" (click)="copyJson()">Copy JSON</button>
                <button type="button" class="btn btn-sm btn-info" (click)="triggerDownloadJson()">Download JSON</button>
            </div>
            <pre class="small mb-0">{{ model() | json }}</pre>
        </accordion-group>
    </accordion>

    <div class="d-flex flex-row justify-content-end gap-2 mt-3">
        <button
            type="button"
            class="btn btn-danger"
            (click)="triggerDelete()"
            translate="PACESPECTOR_DELETE_TIMESHEET"
        ></button>
    </div>
}
